module.exports = __webpack_public_path__ + "img/ht.ht5935076.svg";